import template from './editor.html';
import controller from './editor.controller';
import './editor.scss';

let editorComponent = {
  restrict: 'E',
  bindings: {
    identity: '=',
    content: '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default editorComponent;



// WEBPACK FOOTER //
// ./client/app/common/editor/editor.component.js